import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MtnaErrorModule, MtnaTrackByPropertyPipeModule } from '@mtna/core-angular';

import { GetI18nProcessManagerDownloadeLabelPipe } from './get-i18n-download-label.pipe';
import { RdsProcessManagerComponent } from './process-manager.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MtnaErrorModule,
    MtnaTrackByPropertyPipeModule,
  ],
  declarations: [RdsProcessManagerComponent, GetI18nProcessManagerDownloadeLabelPipe],
  exports: [RdsProcessManagerComponent],
})
export class RdsProcessManagerModule {}
export * from './process-manager.component';
